import postRequest from '../../../../postRequest';

/**
 * Post request for ColorSwatching logs.
 *
 * @param {number} page Page count
 * @param {number} size Page size
 */
export default function postProductTypeLogs(
  page,
  size,
  searchTerm,
  fromDate,
  toDate,

) {
  const fromDateString = fromDate === null ? '' : fromDate;
  const toDateString = toDate === null ? '' : toDate;
  const endpoint = `/oc-data-management/v1/colourMatching/log?searchTerm=${searchTerm}&fromDate=${fromDateString}&toDate=${toDateString}&Page=${page}&Size=${size}`;
  return new Promise((resolve, reject) => {
    postRequest(endpoint, 'ColorSwatching Logs')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
